import {
    LoadingTimeWindow,
    MainRunCarrier,
    MainRunData,
    MainRunProblems,
    MainRunViolation
} from "../../model/mainrun/mainRunData"
import { ICrossDock } from "../../model/crossdock/crossDock"
import {
    CrossDockRest,
    ExternalMainRunProblems,
    ExternalMainRunViolation, MainRunCarrierRest,
    MainRunDataRest,
    TimeWindowRest
} from "./asnMatchingApi.model"

export const toMainRunDataRest = (mainRun: MainRunData): MainRunDataRest => ({
    asn_tracking_number: mainRun.asnTrackingNumber,
    cross_dock_id: mainRun.crossDockId,
    supplier_duns: mainRun.supplierDuns,
    loading_time_window: toTimeWindowRest(mainRun.loadingTimeWindow),
    main_run_carrier: toMainRunCarrierRest(mainRun.mainRunCarrier),
})

const toTimeWindowRest = (loadingTimeWindow: LoadingTimeWindow): TimeWindowRest => ({
    time_from: loadingTimeWindow.timeFrom,
    time_to: loadingTimeWindow.timeTo,
})

const toMainRunCarrierRest = (mainRunCarrier: MainRunCarrier): MainRunCarrierRest => {
    if (mainRunCarrier.type === "SELF") {
        return {
            type: "SELF",
            load_id: mainRunCarrier.loadId,
            asset_id: mainRunCarrier.assetId,
            access_code: mainRunCarrier.accessCode,
        }
    } else {
        return {
            type: "THIRD_PARTY",
            bundle_id: mainRunCarrier.bundleId,
        }
    }
}

export const toMainRun = (src: MainRunDataRest): MainRunData => ({
    asnTrackingNumber: src.asn_tracking_number,
    crossDockId: src.cross_dock_id,
    supplierDuns: src.supplier_duns,
    loadingTimeWindow: toLoadingTimeWindow(src.loading_time_window),
    mainRunCarrier: toMainRunCarrier(src.main_run_carrier),
})

const toLoadingTimeWindow = (src: TimeWindowRest): LoadingTimeWindow => ({
    timeFrom: src.time_from,
    timeTo: src.time_to,
})

const toMainRunCarrier = (src: MainRunCarrierRest): MainRunCarrier => {
    if (src.type === "SELF") {
        return {
            type: "SELF",
            loadId: src.load_id,
            assetId: src.asset_id,
            accessCode: src.access_code,
        }
    } else {
        return {
            type: "THIRD_PARTY",
            bundleId: src.bundle_id,
        }
    }
}

export const toCrossDock = (src: CrossDockRest): ICrossDock => ({
    name: src.name,
    id: src.id,
})

export const toMainRunProblems = (externalMainRunProblems: ExternalMainRunProblems): MainRunProblems => {
    return {
        violations: externalMainRunProblems.main_run_violations.map(asnMatchingApiConverter),
    }
}

const asnMatchingApiConverter = (externalMainRunDataViolation: ExternalMainRunViolation): MainRunViolation => {
    return {
        index: externalMainRunDataViolation.index,
        errors: externalMainRunDataViolation.errors,
    }
}
